// Shared Google Maps loader config — must be identical everywhere
// CRITICAL: All components using useJsApiLoader MUST use this exact config
// Different configs cause "Loader must not be called again with different options" error
export const GOOGLE_MAPS_CONFIG = {
  id: 'google-map-script',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  libraries: ['places', 'drawing'],
};

// For components that just need the isLoaded state
export const useGoogleMaps = () => {
  // This is a placeholder - actual hook usage should import useJsApiLoader directly with GOOGLE_MAPS_CONFIG
  return null;
};
